export default {
    apiHost: process.env.VUE_APP_API_HOST || "https://mis-redes-api.herokuapp.com"//"http://api.misred-dev.es:8000"
}